import { useScrollReveal } from '../hooks/useScrollReveal';
import { useTilt } from '../hooks/useTilt';
import { ExternalLinkIcon } from './icons';

const LINK_LABELS = {
  live: 'Visit',
  appStore: 'App Store',
  playStore: 'Google Play',
  github: 'GitHub',
};

export function ProjectCard({ project, index, onPrivacy }) {
  const [contentRef, contentVisible] = useScrollReveal();
  const [imageRef, imageVisible] = useScrollReveal();
  const tilt = useTilt({ max: 7, scale: 1.03 });
  const isEven = (index + 1) % 2 === 0;
  const contentDir = isEven ? 'reveal-right' : 'reveal-left';
  const imageDir = isEven ? 'reveal-left' : 'reveal-right';
  const links = Object.entries(project.links || {}).filter(([, url]) => url);

  return (
    <article id={project.id} className="project">
      <span className="project-number">{project.number}</span>

      <div ref={contentRef} className={`project-content ${contentDir} ${contentVisible ? 'visible' : ''}`}>
        {project.tagline && <span className="project-tagline">{project.tagline}</span>}
        <h3 className="project-title">{project.title}</h3>
        <div className="project-description">
          {project.description}
          {project.hasPrivacyLink && (
            <button className="ghost-btn" onClick={onPrivacy}>
              View Privacy Policy <ExternalLinkIcon />
            </button>
          )}
        </div>
        <div className="tech-stack">
          {project.techStack.map((tech) => (
            <span key={tech} className="tech-pill">{tech}</span>
          ))}
        </div>
        {links.length > 0 && (
          <div className="project-links">
            {links.map(([key, url]) => (
              <a key={key} href={url} target="_blank" rel="noopener noreferrer" className="ghost-btn">
                {LINK_LABELS[key] || key} <ExternalLinkIcon />
              </a>
            ))}
          </div>
        )}
      </div>

      <div ref={imageRef} className={`project-image ${imageDir} ${imageVisible ? 'visible' : ''}`}>
        <div
          className="project-image__frame"
          ref={tilt.ref}
          onMouseMove={tilt.onMouseMove}
          onMouseLeave={tilt.onMouseLeave}
        >
          <div className={project.imageClass} />
        </div>
      </div>
    </article>
  );
}
